module.exports = __webpack_public_path__ + "img/Beifahrerseite_1T_C_Heckmotor.c0fdac40.jpg";